/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LabelFilter
 */
export interface LabelFilter {
    /**
     * 
     * @type {boolean}
     * @memberof LabelFilter
     */
    enabled: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof LabelFilter
     */
    labels?: Array<string>;
}

export function LabelFilterFromJSON(json: any): LabelFilter {
    return LabelFilterFromJSONTyped(json, false);
}

export function LabelFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): LabelFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'labels': !exists(json, 'labels') ? undefined : json['labels'],
    };
}

export function LabelFilterToJSON(value?: LabelFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'labels': value.labels,
    };
}

